// @flow
export { default } from './DeleteConfirmation';
